// extracted by mini-css-extract-plugin
module.exports = {"button":"FloatingEditButton_button__U4125","container":"FloatingEditButton_container__qKvnZ"};